/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './withdrawJoinRequest.defs'
export { main as default } from './withdrawJoinRequest.defs'
